// extracted by mini-css-extract-plugin
export default {"heading":"UC","container":"VC","product_section_row":"WC","carousel":"XC","carouselwide":"YC","carouselwrapper":"ZC","blockwrapper":"aE","product_carousel_row":"bE","headingnarrow":"cE","title":"eE"};
    if(module.hot) {
      // 1713809678249
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  